(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(59622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86886);
/* harmony import */ var _care_react_pages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56975);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56721);
/* harmony import */ var _components_common_SeoGlobalNavbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28528);






function Custom404(param) {
    var _showGlobalNav = param.showGlobalNav, showGlobalNav = _showGlobalNav === void 0 ? true : _showGlobalNav;
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isEmbraceTheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        container: true,
        children: [
            showGlobalNav && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_SeoGlobalNavbar__WEBPACK_IMPORTED_MODULE_1__/* .SeoGlobalNavbar */ .L, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                py: 3,
                px: 9,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_pages__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        prev: "/"
                    }),
                    ";"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: isEmbraceTheme ? "inverse" : "default"
                })
            })
        ]
    });
}


/***/ }),

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _components_pages_404__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _components_pages_404__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56169);



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,6537,4690,6886,9417,9263,4888,8528,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);